// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAnswers_modal__K86eW","fadeInDown":"ModalAnswers_fadeInDown__3CrtG","modal__content":"ModalAnswers_modal__content__2Hx1y"};